import React, { useEffect, useState } from "react";
import "../../style/ReuploadScan.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../style/ReuploadScan.css";
import { useNavigate } from "react-router-dom";
import { apiAxios } from "../../utils/apiAxios";
export interface ReuploadScanProps {
  order: any; // or OrderType if you have it here
  onReuploadClick?: (caseID: number) => void;
  onClose?: () => void;   // 👈 ADD THIS
  onCancelClick?: () => void;
}

const ReuploadScan: React.FC<ReuploadScanProps> = ({
  order,
  onReuploadClick,
  onClose,
  onCancelClick,

}) => {


  const [orderDetails, setOrderDetails] = useState<any[]>([]);
  const [errorDetails, setErrorDetails] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const orderHeader = orderDetails && orderDetails.length > 0 ? orderDetails[0] : null;
  const isWarrantyClaim = orderHeader?.dentistTag?.toLowerCase() === "warranty claimed";



  const navigate = useNavigate();

  useEffect(() => {

    if (order?.caseID) {
      fetchReuploadScanDetail();
    }
  }, [order]);


  const fetchReuploadScanDetail = async () => {
  
    try {
      setLoading(true);

      const token = sessionStorage.getItem("token");

      const response = await apiAxios.post(
        `${process.env.REACT_APP_API_BASE_URL}/Dentist/GetReuploadScanDetail`,
        {
          CaseIDs: [order.caseID],
        },
        {
          headers: {
            AuthorizationData: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data?.isSuccess) {
        setOrderDetails(response.data.singleData);
        
        setErrorDetails(response.data.errors);

      }

    } catch (error) {
      console.error("Reupload detail error:", error);
      toast.error("Failed to load scan details");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="order-wrapper mt-4">

      {/* Order Card */}
      {isWarrantyClaim && (
        <div className="alert alert-info mb-3">
          <strong>Warranty Claim Case</strong>
        </div>
      )}
      <div className="order-card">
        <div className="order-header">
          <div>
            {orderHeader && (
              <div>
                <strong className="number-fontweight">
                  {orderHeader.orderID}
                </strong>
                &nbsp; {orderHeader.patientName}
              </div>
            )}
          </div>

          <div className="header-actions">
            {/* <span className="close-btn">✕</span> */}

            <span
              className="close-btn"
              style={{ cursor: "pointer" }}
              onClick={onClose}
            >
              ✕
            </span>

          </div>
        </div>

        <div className="eta order-header py-2">
          <div className="ETA_main">


          </div>
          <button className="reupload-badge">
            <i className="bi bi-exclamation-circle-fill me-1 text-white"></i>

            {order?.dentistTag}

          </button>


        </div>
        <div className="table-div-main">

          {loading ? (
            <div
              style={{
                padding: "20px",
                textAlign: "center",
                fontSize: "14px",
                color: "#666",
              }}
            >
              Loading scan details...
            </div>
          ) : (
          <div className="table-scroll-wrapper">
  <table className="order-table order-table-dentist">
              <thead>
                <tr>
                  <th>Tooth</th>
                  <th>Material</th>
                  <th>Shade</th>
                </tr>
              </thead>
              <tbody>
                {orderDetails.length > 0 ? (
                  orderDetails.map((item, index) => (
                    <tr key={index}>
                      <td>{item.toothNumber}</td>
                      <td>{item.materialName}</td>
                      <td>{item.shade}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} style={{ textAlign: "center", padding: "12px" }}>
                      No scan details found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            </div>
          )}

        </div>

        <div className="order-footer pb-2 pt-3">
          <button
  className="btn btn-contact-section gray"
  onClick={() => {
   

    navigate("/dentist/ContactSupport", {
      state: {
        caseIds: [order?.caseID],
        orderId: order?.orderID,
      },
    });
  }}
>
  Contact Support
</button>
          {!isWarrantyClaim &&
            order?.dentistTag !== "Cancelled" &&
            order?.dentistTag !== "Cancellation Under Review" &&
            order?.dentistTag !== "Completed" && (
              <button
                className="btn btn-contact-section red"
                onClick={onCancelClick}
              >
                Cancel Order
              </button>
            )}
        </div>
      </div>

      {/* Re-upload Section */}
      <div className="reupload-box">

        {!isWarrantyClaim && (
          <>
            <ul>
              <li>
                <strong className="number-fontweight re-upload-scan">
                  Reasons for re-upload scan
                </strong>
              </li>
            </ul>

            <ul className="px-5">
              {errorDetails.length > 0 ? (
                errorDetails.map((item, index) => (
                  <li key={index}>
                    {item} {index === 0 && <span style={{ color: "red" }}>*</span>}
                  </li>
                ))
              ) : (
                <li>No errors found</li>
              )}
            </ul>
          </>
        )}

        <button
          className="btn blue full"
          onClick={() => {
            onReuploadClick?.(order?.caseID);
          }}
        >
          Re-upload Scan
        </button>

      </div>
    </div>
  );
};

export default ReuploadScan;
